import React, { ReactNode } from 'react';

import { OnboardingData, OnboardingUpdates } from 'registration/types';

export type OnboardingStepContextType = {
  addTalentProfileKeys: (string) => void;
  isUpdatingProfile: boolean;
  completeStep: (newTalentProfileUpdates: OnboardingUpdates) => void;
  maybeGoToNext: () => void;
  maybeGoToPrevious: () => void;
  localStepTalentProfile: OnboardingData;
  setLocalStepTalentProfile: React.Dispatch<
    React.SetStateAction<OnboardingData>
  >;
};

const OnboardingStepContext =
  React.createContext<OnboardingStepContextType>(null);

type OnboardingStepProviderProps = {
  config: OnboardingStepContextType;
  children: ReactNode;
};
export const OnboardingStepProvider = ({
  config,
  children,
}: OnboardingStepProviderProps) => (
  <OnboardingStepContext.Provider value={config}>
    {children}
  </OnboardingStepContext.Provider>
);

export const useOnboardingStepContext = () =>
  React.useContext(OnboardingStepContext);
